import { AbstractTypeEntityFacade } from '../abstractions/AbstractTypeEntityFacade';
import { ContactTypesService } from '@control-tower/platform-core';
import { Injectable } from '@angular/core';
import { LoggerService } from '@pf/shared-services';
import { TypeEntityStore } from '../stores/TypeEntityStore';
import { TypeEntityTypes } from '@pf/shared-common';

@Injectable()
export class ContactTypeFacade extends AbstractTypeEntityFacade<ContactTypesService> {
    constructor(
        typeService: ContactTypesService,
        store: TypeEntityStore,
        logger: LoggerService
    ) {
        super(
            store,
            logger,
            typeService,
            'contactTypeGetAll',
            TypeEntityTypes.ContactType
        );
    }
}
